import React from 'react';
import { isPowerUser } from '../auth/authUtils';
import HomeAdvanced from './HomeAdvanced';
import HomeBasic from './HomeBasic';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

function Home() {
  usePageTitle(['Home']);

  const currentUser = useAppSelector((state) => state.auth);

  return isPowerUser(currentUser) ? <HomeAdvanced /> : <HomeBasic />;
}

export default Home;
